import GPT from "../gpt/GPT";
import Ad from "../gpt/Ad";

/**
 * Always render ad
 */
export default class CompanionAdRenderingStrategy {

    /**
     * @constructs CompanionAdRenderingStrategy
     */

    _gpt: GPT;
    _services: string[];

    constructor(gpt: GPT) {
        this._gpt = gpt;
        this._services = [gpt.services.pubads, gpt.services.companionAds];
    }

    /**
     * Add the ad to the set of unrendered ads and start the state machine
     */
    render(ad: Ad): void {
        if (ad.isDisplayable()) {
            this._gpt.render(ad, { display: false, services: this._services });
        }
    }

    /**
     * noop - Has no implementation
     */
    refresh(ads: Ad[]) { // eslint-disable-line @typescript-eslint/no-unused-vars
    }

}
